import axios from "axios";
import { toast } from "../components/ui/use-toast";

export function defaultBaseUrl() {
  return "https://stagapi.trustsoft.com.au";
}

const baseURL = defaultBaseUrl() + "/api/v1";

//set config when creating the instance
const instance = axios.create({
  baseURL: baseURL,
});

//add a request interceptor

instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("ts-auth-token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    config.headers["Accept"] = "application/json";
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers["timeout"] = 5000;

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

export const refreshAPI = async () => {
  const headers = {
    "Content-Type": "application/json",
  };
  const token = localStorage.getItem("ts-refresh-token");
  headers["Authorization"] = "Bearer " + token;
  await axios
    .post(`${baseURL}/refresh`, "", { headers: headers })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem("ts-auth-token", res.data.access_token);
        localStorage.setItem("ts-refresh-token", res.data.refresh_token);
      }
    })
    .catch((error) => {
      setTimeout(() => {
        localStorage.setItem("DefaultURL", window.location.pathname);
        localStorage.setItem(
          "token-expired-email",
          localStorage.getItem("ts-auth-email"),
        );
        localStorage.removeItem("ts-auth-token");
        localStorage.removeItem("EmailVerification");
        localStorage.removeItem("userId");
        localStorage.removeItem("ProfilePhoto");
        localStorage.removeItem("Name");
        localStorage.removeItem("role");
        localStorage.removeItem("roleType");
        localStorage.removeItem("AccountingFirmLogo");
        localStorage.removeItem("BusinessName");
        // localStorage.clear();
        window.location.href = "/";
      }, 2000);
    });
};

// Add a response interceptor

instance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response?.data?.message) {
        toast({
          variant: "success",
          description: response?.data?.message,
          duration: 3000,
        });
      }

      if (response.data.status === "Token Expired. Please try again.") {
        localStorage.setItem("DefaultURL", window.location.pathname);
        localStorage.setItem(
          "token-expired-email",
          localStorage.getItem("ts-auth-email"),
        );
        localStorage.removeItem("ts-auth-token");
        // localStorage.removeItem("ts-auth-email");
        localStorage.removeItem("EmailVerification");
        localStorage.removeItem("userId");
        localStorage.removeItem("ProfilePhoto");
        localStorage.removeItem("Name");
        localStorage.removeItem("role");
        localStorage.removeItem("roleType");
        localStorage.removeItem("AccountingFirmLogo");
        localStorage.removeItem("BusinessName");
        // localStorage.clear();
        window.location.href = "/";
      }
      if (response.data.status === 401) {
        localStorage.clear();
        // window.location.href = "/";
      }
    }
    return response;
  },

  function (error) {
    const originalRequest = error.config;

    const headers = {
      "Content-Type": "application/json",
    };
    const token = localStorage.getItem("ts-refresh-token");
    headers["Authorization"] = "Bearer " + token;

    if (error?.response?.data?.errors) {
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        toast({
          variant: "destructive",
          description: error?.response?.data?.errors[key][0],
          duration: 3000,
        });
      });
    } else {
      error?.response?.data?.message &&
        toast({
          variant: "destructive",
          description: error?.response?.data?.message,
          duration: 3000,
        });
    }

    //token expired
    if (
      error?.response?.status === 419 &&
      originalRequest.url !== "/reset-password"
    ) {
      return axios
        .post(`${baseURL}/refresh`, "", { headers: headers })
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("ts-auth-token", res.data.access_token);
            localStorage.setItem("ts-refresh-token", res.data.refresh_token);
            window.location.reload();
          }
        })
        .catch((error) => {
          setTimeout(() => {
            localStorage.setItem("DefaultURL", window.location.pathname);
            localStorage.setItem(
              "token-expired-email",
              localStorage.getItem("ts-auth-email"),
            );
            localStorage.removeItem("ts-auth-token");
            localStorage.removeItem("EmailVerification");
            localStorage.removeItem("userId");
            localStorage.removeItem("ProfilePhoto");
            localStorage.removeItem("Name");
            localStorage.removeItem("role");
            localStorage.removeItem("roleType");
            localStorage.removeItem("AccountingFirmLogo");
            localStorage.removeItem("BusinessName");
            // localStorage.clear();
            window.location.href = "/";
          }, 2000);
        });
    }

    //if user unauthorised then redirect to login
    if (error?.response?.status === 401) {
      if (
        error?.response?.data?.errors?.ts_error[0] ===
        "Incorrect Email or Password"
      ) {
        localStorage.clear();
      } else {
        localStorage.clear();
        window.location.href = "/";
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

export default instance;
